import React from 'react';
import { useForm } from 'react-hook-form';
import { useSendPushNotificationMutation } from '@/queries/push/useSendPushNotificationMutation';
import { Button, FormRow } from '../../controls';
import { EventRelatedSection } from '../EventRelatedSection';

export function PushNotificationsSection({ festivalId }) {
  const sendMutation = useSendPushNotificationMutation(festivalId);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { text: '' },
    mode: 'onSubmit',
  });

  const onSubmit = (values) => {
    sendMutation.mutate(values, {
      onSuccess: () => {
        reset({ text: '' });
      },
    });
  };

  return (
    <EventRelatedSection
      icon={['fas', 'bell']}
      title="Push Notifications"
      contentOnly
    >
      <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
        <FormRow label="Message" error={errors.text?.message}>
          <textarea
            placeholder="Message"
            {...register('text', { required: 'Message is required' })}
          />
        </FormRow>
        <div className="flex justify-end">
          <Button type="submit" disabled={sendMutation.isPending} mode="dark">
            Send Notification
          </Button>
        </div>
      </form>
    </EventRelatedSection>
  );
}
